  module.exports = {
  template: 'admin-assistant',

  fieldSelector: 'li[id^="project_"][id$="_input"]',

  viewerIdStyles: {
    project_header_color:                        'background-color',
    project_background_color:                    'background-color',
    project_hint_background_color:               'background-color',
    project_question_background_color:           'background-color',
    project_answer_background_color:             'background-color',
    project_source_button_color:                 'background-color',
    project_typing_dots_color:                   'dot-bg-color',
    project_input_area_color:                    'background-color',
    project_terms_conditions_background_color:   'background-color',

    project_icon_chat_background_color_from:     'stop-color',
    project_icon_chat_background_color_to:       'stop-color',
    project_icon_chat_text_color:                'fill',
    project_icon_chat_hover_background_color:    'fill',
    project_icon_chat_hover_text_color:          'fill',
    project_icons_chat_close_border_color:       'stroke',

    project_icon_close_background_color_from:    'stop-color',
    project_icon_close_background_color_to:      'stop-color',
    project_icon_close_text_color:               'fill',
    project_icon_close_hover_background_color:   'fill',
    project_icon_close_hover_text_color:         'fill',

    project_hint_text_color:                     'color',
    project_header_text_color:                   'color',
    project_hello_text_color:                    'color',
    project_question_answer_title_color:         'color',
    project_chat_question_title_color:           'color',
    project_question_answer_subtitle_color:      'color',
    project_chat_question_subtitle_color:        'color',
    project_question_answer_textcolor:           'color',
    project_chat_question_text_color:            'color',
    project_chat_answer_text_color:              'color',
    project_chat_answer_title_color:             'color',
    project_chat_answer_subtitle_color:          'color',
    project_link_color:                          'color',
    project_source_button_text_color:            'color',
    project_limit_text_color:                    'color',
    project_typing_text_color:                   'color',
    project_question_text_color:                 'color',
    project_terms_conditions_link_color:         'color',

    project_question_placeholder_color:          'style-placeholder-color',

    project_main_font_url:                       'font-setting',
    project_title_font_url:                      'font-setting',
    project_font_scale:                          'font-setting',
    project_hint_font_size:                      'font-setting',

    project_hint_window_width:                   'width-px',
    project_text_icon_length:                    'text-icon-length',
    project_text_icon_mobile_length:             'text-icon-mobile-length',
    project_text_icon_font_size:                 'font-size-px',
    project_text_icon_close_font_size:           'font-size-px',
    project_source_button_border_radius:         'border-radius-px',
    project_source_button_margin_top_bottom:     'padding-tb-px',
    project_source_button_margin_right_left:     'padding-lr-px',

    project_hint_border_color:                   'border-color',
    project_border_color:                        'border-color',
    project_source_button_border_color:          'border-color',
    project_input_border_color:                  'border-color',

    project_icon_font_size_change_color:         'stroke',
    project_icon_dark_mode_color:                'stroke',
    project_icon_light_mode_color:               'stroke',
    project_icon_scroll_down_color:              'stroke',
    Intf_IconScrollUp:                            'stroke',
    project_icon_thumb_border_color:             'stroke',

    project_icon_resize_color:                   'fill',
    project_icon_main_window_close_color:        'fill',
    project_icon_hello_color:                    'fill',
    Intf_IconSessionRestart:                     'fill',
    project_icon_send_background_color:          'fill',
    project_icon_send_color:                     'fill',
    project_icon_send_hover_background_color:    'fill',
    project_icon_send_hover_color:               'fill',
    project_icon_input_question_color:           'fill',
    project_icon_thumb_background_color:         'fill',

    project_icon_copy_button_color:              'details',

    Intf_CopyButtonTextColor:                    'color',
    Intf_CopyButtonHoverTextColor:               'style-hover-color',
    Intf_CopyButtonIconColor:                    'stroke',
    Intf_CopiedButtonTextColor:                  'style-copied-color',
    Intf_CopiedButtonIconColor:                  'stroke',

    project_icon_answer_text_color:              'fill',
    project_icon_answer_background_color_from:   'stop-color',
    project_icon_answer_background_color_to:     'stop-color',
    project_icon_answer_scale_assistant:         'transform-scale',
    project_close_open_icons_scale:              'zoom-scale',

    project_icon_question_text_color:            'fill',
    project_icon_question_background_color_from: 'stop-color',
    project_icon_question_background_color_to:   'stop-color',

    Intf_SourceLinkButtonColorHover:       'source-hover-bg',
    Intf_SourceLinkButtonTextColorHover:   'source-hover-text',
    Intf_SourceLinkButtonBorderColorHover: 'source-hover-border',
  },

  textViewerFields: [
    'header_text',
    'welcome_message_title',
    'welcome_message_subtitle',
    'question_message_title',
    'question_message_subtitle',
    'answer_message_title',
    'answer_message_subtitle',
    'typing_text',
    'hint_message',
  ],

  viewerValueFields: [
    'hint_window_width',
    'text_icon_length',
    'source_button_border_radius',
    'source_button_margin_top_bottom',
    'source_button_margin_right_left',
    'main_font_url',
    'title_font_url',
    'font_scale',
    'hint_font_size',
    'first_message_text',
    'icon_answer_scale_assistant',
    'close_open_icons_scale',
  ],

  tabs: [
    { id: '#branding', default: true },
    { id: '#widget-settings', settings: [
      'project_feedback', 'project_resize', 'project_copy',
      'project_theme_switch', 'project_font_size_switch',
      'project_header_text', 'project_question_placeholder_text',
      'project_welcome_message_title', 'project_welcome_message_subtitle',
      'project_question_message_title', 'project_question_message_subtitle',
      'project_answer_message_title', 'project_answer_message_subtitle',
      'project_hint_message', 'project_typing_text',
      'project_text_icon_text', 'project_text_icon_close_text',
      'project_first_message_text', 'project_text_icon_length',
      'project_text_icon_font_size', 'project_text_icon_close_font_size',
      'project_text_icon_mobile_length', 'project_text_icon_mobile_text',
      'project_typing_label_position',
    ]},
  ],

  scrollPositions: {
    project_first_message_text:                  0,
    project_welcome_message_title:               0,
    project_welcome_message_subtitle:            0,
    project_question_message_title:              250,
    project_question_message_subtitle:           250,
    project_title_font_url:                      250,
    project_answer_message_title:                500,
    project_answer_message_subtitle:             500,
    project_icon_hello_color:                    0,
    project_hello_text_color:                    0,
    project_chat_question_title_color:           250,
    project_chat_question_subtitle_color:        250,
    project_chat_question_text_color:            250,
    project_question_background_color:           250,
    project_question_answer_title_color:         250,
    project_question_answer_subtitle_color:      250,
    project_chat_answer_title_color:             500,
    project_chat_answer_subtitle_color:          500,
    project_chat_answer_text_color:              500,
    project_answer_background_color:             500,
    project_question_answer_textcolor:           500,
    project_link_color:                          500,
    project_source_button:                       500,
    project_source_button_text_color:            500,
    project_source_button_border_color:          500,
    project_source_button_color:                 500,
    project_source_button_border_radius:         500,
    project_source_button_margin_top_bottom:     500,
    project_source_button_margin_right_left:     500,
    project_icon_copy_button_color:              500,
    project_feedback:                            500,
    project_icon_thumb_background_color:         500,
    project_icon_thumb_border_color:             500,
    project_copy:                                500,
    project_icon_answer_text_color:              500,
    project_icon_answer_background_color_from:   500,
    project_icon_answer_background_color_to:     500,
    project_icon_answer_scale_assistant:         250,
    project_icon_question_text_color:            250,
    project_icon_question_background_color_from: 250,
    project_icon_question_background_color_to:   250,
    Intf_CopyButtonTextColor:                     500,
    Intf_CopyButtonHoverTextColor:                500,
    Intf_CopyButtonIconColor:                     500,
    Intf_CopiedButtonTextColor:                   500,
    Intf_CopiedButtonIconColor:                   500,
    Intf_SourceLinkButtonColorHover:               500,
    Intf_SourceLinkButtonTextColorHover:           500,
    Intf_SourceLinkButtonBorderColorHover:         500,
  },

  customSettings: {
    Intf_CopyButtonTextColor: {
      description: 'Color of the "Copy" text in the copy button',
      default: null,
    },
    Intf_CopyButtonHoverTextColor: {
      description: 'Text color of the copy button on hover',
      default: null,
    },
    Intf_CopyButtonIconColor: {
      description: 'Color of the copy button icon',
      default: null,
    },
    Intf_CopiedButtonTextColor: {
      description: 'Text color of the copy button in the "Copied" state',
      default: null,
    },
    Intf_CopiedButtonIconColor: {
      description: 'Color of the copy button icon in the "Copied" state',
      default: null,
    },
    Intf_inputLimit: {
      description: 'Maximum number of characters allowed in the question input field',
      type: 'number',
      default: 200,
      onChange: function(value) {
        var input = document.getElementById('question-intf');
        if (input) input.maxLength = value;
        var label = document.getElementById('limit-label-value-intf');
        if (label) label.textContent = value;
      },
    },
    Intf_QuestionOnTop: {
      description: 'Controls where the chat auto-scrolls after a new answer. Default true: scrolls so the last question sits at the top. If false: scrolls to the bottom so the last answer is fully visible instead, which may leave the last question partially or fully hidden above it',
      type: 'boolean',
      default: true,
    },
    Intf_SourceLinkButtonColorHover: {
      description: 'Background color of the source button on hover',
      default: '#3074FF',
    },
    Intf_SourceLinkButtonTextColorHover: {
      description: 'Text color of the source button on hover',
      default: '#FFFFFF',
    },
    Intf_SourceLinkButtonBorderColorHover: {
      description: 'Border color of the source button on hover',
      default: '#3074FF',
    },
    Intf_IconScrollUp: {
      description: 'Color of the "scroll up" icon. Overrides the scroll-down color for this icon only; if unset, it inherits the scroll-down color',
      default: null,
    },
    Intf_zindexValue: {
      description: 'Z-index for the widget window and widget button. This setting has no visual effect in this editor\'s preview.',
      type: 'number',
      default: 2147483647,
    },
    Intf_zindexDynamic: {
      description: 'Enables dynamic calculation of the z-index instead of using the fixed Intf_zindexValue. This setting has no visual effect in this editor\'s preview.',
      type: 'boolean',
      default: false,
    },
    Intf_IconChatTextMobileFontSize: {
      description: 'Font size of the closed widget button label in the mobile version (text-icon mode)',
      type: 'number',
      default: null,
      onChange: function(value) {
        var el = document.querySelector('#icon-chat-open-text-intf svg.mobile-normal-intf');
        if (!el) return;
        var fontSize = (value || 16) + 'px';
        el.querySelectorAll('text').forEach(function(t) { t.style.fontSize = fontSize; });
      },
    },
    Intf_IconChatHoverTextMobileFontSize: {
      description: 'Font size of the closed widget button label in the mobile version, in the hover state (text-icon mode)',
      type: 'number',
      default: null,
      onChange: function(value) {
        var el = document.querySelector('#icon-chat-open-text-intf svg.mobile-hover-intf');
        if (!el) return;
        el.querySelectorAll('text').forEach(function(t) { t.style.fontSize = (value || 16) + 'px'; });
      },
    },
    Intf_IconChatMobileHoverFullText: {
      description: 'Text-icon label shown on the closed widget button in the mobile version, in the hover state (falls back to the desktop hover label, then the normal label, if unset)',
      type: 'text',
      multiline: true,
      maxLines: 3,
      default: null,
      onChange: function() { window.jQuery('#project_text_icon_text').trigger('input'); },
    },
    Intf_IconChatHoverTextFontSize: {
      description: 'Font size of the closed widget button label in the hover state (text-icon mode)',
      type: 'number',
      default: 16,
      onChange: function(value) {
        var el = document.querySelector('#icon-chat-open-text-intf svg.icon-intf.hidden-intf');
        if (!el) return;
        el.querySelectorAll('text').forEach(function(t) { t.style.fontSize = (value || 16) + 'px'; });
      },
    },
    Intf_IconCloseHoverTextFontSize: {
      description: 'Font size of the open widget button label in the hover state (text-icon mode)',
      type: 'number',
      default: 16,
      onChange: function(value) {
        var el = document.querySelector('#icon-chat-close-text-intf svg.icon-intf.hidden-intf');
        if (!el) return;
        el.querySelectorAll('text').forEach(function(t) { t.style.fontSize = (value || 16) + 'px'; });
      },
    },
    Intf_IconChatHoverFullText: {
      description: 'Text-icon label shown on the closed widget button in the hover state (falls back to the normal label if unset)',
      type: 'text',
      multiline: true,
      maxLines: 3,
      default: null,
      onChange: function() { window.jQuery('#project_text_icon_text').trigger('input'); },
    },
    Intf_IconCloseHoverFullText: {
      description: 'Text-icon label shown on the open widget button in the hover state (falls back to the normal label if unset)',
      type: 'text',
      multiline: true,
      maxLines: 3,
      default: null,
      onChange: function() { window.jQuery('#project_text_icon_close_text').trigger('input'); },
    },
    Intf_iconSizeScaleMobile: {
      description: 'Resizing of the mobile version of the open chat icon relative to the desktop size (ratio from 0 to 1)',
      type: 'number',
      step: 'any',
      default: 0.6923,
      onChange: function(value) {
        document.querySelectorAll('.mobile-preview').forEach(function(el) { el.style.transform = 'scale(' + (value || 0.6923) + ')'; });
      },
    },
    Intf_sessionRestartButton: {
      description: 'Enables the user session reset button, shown as an icon next to the header controls',
      type: 'boolean',
      default: false,
      onChange: function(value) {
        var el = document.getElementById('session-restart-container-intf');
        if (el) el.style.display = (value === 'true') ? '' : 'none';
      },
    },
    Intf_IconSessionRestart: {
      label: 'Icon session restart color',
      description: 'Color of the user session reset button icon',
      default: '#7D888F',
    },
    Intf_IconReviewWindowClose: {
      label: 'Icon review window close color',
      description: 'Color of the review window close icon. This setting has no visible element in this editor\'s preview.',
      default: '#5E6A71',
    },
    Intf_ButtonCloseHidden: {
      description: 'Hides the widget\'s close button entirely',
      type: 'boolean',
      default: false,
      onChange: function(value) {
        var el = document.getElementById('icon-window-close-container-intf');
        if (el) el.style.display = (value === 'true') ? 'none' : '';
      },
    },
  },

  priorityById: {
    project_chat_question_title_color:    'project_chat_question_title_color',
    project_chat_question_subtitle_color: 'project_chat_question_subtitle_color',
    project_chat_question_text_color:     'project_chat_question_text_color',
    project_chat_answer_text_color:       'project_chat_answer_text_color',
    project_chat_answer_title_color:      'project_chat_answer_title_color',
    project_chat_answer_subtitle_color:   'project_chat_answer_subtitle_color',
    Intf_CopyButtonTextColor:             'Intf_CopyButtonTextColor',
    Intf_CopyButtonIconColor:             'Intf_CopyButtonIconColor',
    Intf_CopiedButtonTextColor:           'Intf_CopiedButtonTextColor',
    Intf_CopiedButtonIconColor:           'Intf_CopiedButtonIconColor',
    Intf_IconScrollUp:                    'Intf_IconScrollUp',
  },

  guardById: {
    project_question_answer_title_color:    new Set(['project_chat_question_title_color',    'project_chat_answer_title_color']),
    project_question_answer_subtitle_color: new Set(['project_chat_question_subtitle_color', 'project_chat_answer_subtitle_color']),
    project_question_answer_textcolor:      new Set(['project_chat_question_text_color',     'project_chat_answer_text_color']),
    project_icon_copy_button_color:         new Set(['Intf_CopyButtonTextColor',             'Intf_CopyButtonIconColor', 'Intf_CopiedButtonTextColor', 'Intf_CopiedButtonIconColor']),
    project_icon_scroll_down_color:         new Set(['Intf_IconScrollUp']),
  },

  fallbackById: {
    project_chat_question_title_color:    'project_question_answer_title_color',
    project_chat_answer_title_color:      'project_question_answer_title_color',
    project_chat_question_subtitle_color: 'project_question_answer_subtitle_color',
    project_chat_answer_subtitle_color:   'project_question_answer_subtitle_color',
    project_chat_question_text_color:     'project_question_answer_textcolor',
    project_chat_answer_text_color:       'project_question_answer_textcolor',
    Intf_CopyButtonTextColor:             'project_icon_copy_button_color',
    Intf_CopyButtonIconColor:             'project_icon_copy_button_color',
    Intf_CopiedButtonTextColor:           'project_icon_copy_button_color',
    Intf_CopiedButtonIconColor:           'project_icon_copy_button_color',
    Intf_IconScrollUp:                    'project_icon_scroll_down_color',
  },
};
